<template>
  <div  ref="leftScrollRef">
    <div class="setUpAssociatePartnership">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-lianmengyingxiao"></use>
      </svg>
    </breadcrumbs>
    <a-steps :current="currentStep" :items="stepItem"></a-steps>
    </div>
    <SelectBrandsStep :selectedBrands="selectedBrands" :selectedRowKeysId="selectedRowKeysId" v-if="currentStep === 0" @goNext="handleGoNext" />
    <SelectBrandsStepTwo v-if="currentStep === 1" @goBack="handleBack" @goNext="handleGoNextTwo"
      :selectedBrands="selectedBrands" :selectedRowKeysId="selectedRowKeysId" />
    <SelectBrandsStepThree v-if="currentStep === 2" :isAcc="isAcc" @confirm="handleConfirm" />
    <tipModal ref="tipModalRef" @confirm="handleConfirm" @cancel="handleCancel" />
  </div>
</template>
<script setup>
import { onMounted, ref, watch, h, nextTick } from 'vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
import SelectBrandsStep from './components/SelectBrandsStep.vue'
import SelectBrandsStepTwo from './components/SelectBrandsStepTwo.vue'
import SelectBrandsStepThree from './components/SelectBrandsStepThree.vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import tipModal from './components/tipModal.vue'
const router = useRouter()
const route = useRoute()
const isAcc = ref(route.query.isAcc)
const selectedBrands = ref([])
const selectedRowKeysId = ref([])
const tipModalRef = ref(null)
const isLeave = ref(false)
const breadcrumbsData = ref({
  title: 'Set Up Commission',
  color: '#5089FA',
  links: [
    {
      name: 'Associate Central',
      path: '/seller/associateCentral/publishers'
    },
    {
      name: 'Publishers',
      path: '/seller/associateCentral/publishers'
    },
    {
      name: 'Set Up Commission',
      path: '/seller/associateCentral/setUpAssociatePartnership'
    }
  ]
})
const leftScrollRef = ref(null)
onMounted(() => {
  if (isAcc.value == 'false') {
    breadcrumbsData.value = {
      title: 'Set Up Commission',
      color: '#5089FA',
      links: [
        {
          name: 'Home',
          path: '/seller/dashboard'
        },
        {
          name: 'Publishers',
          path: '/seller/publishers'
        },
        {
          name: 'Set Up Commission',
          path: '/seller/associateCentral/setUpAssociatePartnership'
        }
      ]
    }
  } else {
    breadcrumbsData.value = {
      title: 'Set Up Commission',
      color: '#5089FA',
      links: [
        {
          name: 'Associate Central',
          path: '/seller/associateCentral/publishers'
        },
        {
          name: 'Publishers',
          path: '/seller/associateCentral/publishers'
        },
        {
          name: 'Set Up Commission',
          path: '/seller/associateCentral/setUpAssociatePartnership'
        }
      ]
    }
  }
})
const currentStep = ref(0)
const toRouter = ref('')
const stepItem = ref([
  {
    title: 'Select Brand',

  },
  {
    title: 'Set Commissions',
  }
])
// 平滑滚动到顶部的函数
const smoothScrollToTop = () => {
  nextTick(() => {
    // 添加一个小延迟确保DOM完全更新
    setTimeout(() => {
      // 查找页面中所有可滚动的元素
      const scrollableElements = []
      const allElements = document.querySelectorAll('*')
      
      allElements.forEach(element => {
        const computedStyle = window.getComputedStyle(element)
        const overflow = computedStyle.overflow
        const overflowY = computedStyle.overflowY
        const scrollHeight = element.scrollHeight
        const clientHeight = element.clientHeight
        
        if ((overflow === 'auto' || overflow === 'scroll' || overflowY === 'auto' || overflowY === 'scroll') && scrollHeight > clientHeight) {
          scrollableElements.push(element)
        }
      })
      
      // 平滑滚动所有可滚动元素到顶部
      scrollableElements.forEach(element => {
        element.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      })
      
      // 同时尝试平滑滚动窗口
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }, 100)
  })
}

const handleGoNext = (selectedBrandsList, selectedRowKeys, step) => {
  currentStep.value = currentStep.value + 1
  selectedRowKeysId.value = selectedRowKeys
  selectedBrands.value = selectedBrandsList
  
  smoothScrollToTop()
}
const handleGoNextTwo = () => {
  currentStep.value = 2
  
  smoothScrollToTop()
}
const handleBack = () => {
  currentStep.value = 0
  
  smoothScrollToTop()
}
const handleConfirm = () => {
  isLeave.value = true
  router.push(toRouter.value)
}
const handleCancel = () => {

}
onBeforeRouteLeave((to, from, next) => {
  if (!isLeave.value) {
    tipModalRef.value.showModal()
    toRouter.value = to.path
  } else {
    next()
  }
})


</script>
<style scoped lang="less">
.bottomFix {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 64px;
  border: 1px solid #E8E5ED;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 999;

}

.filters {
  display: flex;
  gap: 22px;
  padding: 15px 16px;
  margin: 16px 0;

  border-radius: 8px;
  background: #F8F7FC;

  .filter-item {
    .label {

      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      margin-bottom: 8px;
      opacity: 0.9;
    }
  }

  .checkbox {
    display: flex;
    height: 32px;
    padding: 0 8px;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: #EAE8F0;

  }

  .statusFilter {
    width: 135px;
    // position: relative;
    z-index: 2;
    // margin-left: 18px;
    // opacity: 0.7;
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-2);
    letter-spacing: 0.4px;
    line-height: 20px;
  }
}

.setUpAssociatePartnership {
  padding:0 16px;
  padding-top: unset;
  position: relative;

}

.total {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  color: rgba(15, 6, 41, 1);

}

.bottomFixContent {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  display: flex;
  align-items: center;

  .icon {
    margin: 2px 2px 0;
    font-size: 16px;
  }
}

.totalStyle {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  color: rgba(15, 6, 41, 0.5);
}

.boldBlack {}

.table {
  margin-bottom: 64px;
}

.table-search {
  border-radius: 8px;
  padding: 16px;

  .search-item {}
}

.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
}

.title {
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  color: #0F0629;
  padding-bottom: 16px;
  border-bottom: 1px solid #E8E5ED;
}

.top {
  padding: 20px 16px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 20px;

  .bottom {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;

    .bottom-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      color: #0F0629;

    }
  }
}

.content {
  background-color: #fff;
  border-radius: 8px;
  margin-top: 16px;
  padding: 20px 16px;

}

.table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>